export interface TabData {
	id: string | number
	label: string
	icon?: React.ReactNode
}

interface TabButtonProps extends TabData {
	isActive: boolean
	onClick: () => void
}

const TabButton: React.FC<TabButtonProps> = ({ label, icon, isActive, onClick }) => {
	return (
		<button
			className={`inline-flex items-center gap-2 border-b-2 px-2.5 py-2 text-sm font-medium transition-colors duration-200 ${
				isActive
					? 'text-brand-500 border-brand-500 dark:text-brand-400 dark:border-brand-400'
					: 'text-gray-500 border-transparent hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
			}`}
			onClick={onClick}
		>
			{icon}
			{label}
		</button>
	)
}

interface TabsProps {
	tabs: TabData[]
	activeTabId: TabData['id']
	onTabChange: (tabId: TabData['id']) => void
}

export const Tabs = ({ tabs, activeTabId, onTabChange }: TabsProps) => {
	return (
		<div className="border-b border-gray-200 dark:border-gray-800 mb-4">
			<nav className="flex space-x-2 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-200 dark:scrollbar-thumb-gray-600">
				{tabs.map((tab) => (
					<TabButton key={tab.id} {...tab} isActive={activeTabId === tab.id} onClick={() => onTabChange(tab.id)} />
				))}
			</nav>
		</div>
	)
}
